import type { FunctionComponent } from "react";
import type { UserType } from "@kanda-libs/ks-frontend-services";
import { Button } from "@kanda-libs/ks-design-library";
import useCompanyReportButton from "./useCompanyReportButton";
import CompanyReportModal from "./CompanyReportModal";

export interface CompanyReportButtonProps {
  user: UserType;
}

const CompanyReportButton: FunctionComponent<CompanyReportButtonProps> =
  function ({ user }) {
    const { onShowModal } = useCompanyReportButton();
    return (
      <div className="my-6 mt-2">
        <Button.Text
          id="staff-company-report"
          label="Get company report"
          variant="outline"
          onClick={() => {
            onShowModal();
          }}
        />
        <CompanyReportModal user={user} />
      </div>
    );
  };

export default CompanyReportButton;
